export const defaultMapStyleID = 'streets-v2';

export function buildStyleURL( styleID: string, optimize = false ): string {
    const url = new URL( 'https://api.maptiler.com/maps/' + styleID + '/style.json' );
    url.searchParams.set( 'key', '1gSrAVaVn53NYX4186Wo' );
    url.searchParams.set( 'optimize', optimize.toString() );
    return url.toString();
}
